import { render } from "./NavgatorFIDetalhes.vue?vue&type=template&id=28cc5348"
import script from "./NavgatorFIDetalhes.vue?vue&type=script&lang=js"
export * from "./NavgatorFIDetalhes.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__